// extracted by mini-css-extract-plugin
export default {"banner":"ZPONG","main":"sq8Ll","title":"G8ZfI","textContainer":"kKXJo","text":"cXFd5","note":"KpP3b","imageContainer":"uAI4y"};